import React from 'react';
import { components } from 'react-select';
import { Search } from 'components/SvgIcons';
import { CFM_VOLCANO } from 'constants/Colors';

export default (props) => {
    const className = `${props.className} fm-select__indicator-search`;
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props} className={className}>
                <Search color={CFM_VOLCANO} />
            </components.DropdownIndicator>
        )
    );
};
